// Centralized API URL. Single source for every axios / fetch call.
//
// VITE_API_URL is the FULL base URL the frontend talks to, INCLUDING
// the version segment (e.g. "/api/v1" or "https://host/api/v1"). That
// keeps the version a deploy-time choice, not a source-code constant —
// a frontend bundle can be pointed at /api/v1 or /api/v2 by changing
// the build-arg, no code edit + rebuild required.
//
// See docs/api/versioning.md for the versioning policy.

export const API_URL = (
  import.meta.env.VITE_API_URL ?? 'http://localhost:8000/api/v1'
).replace(/\/+$/, '')
